import { Action } from "@ngrx/store";
import { type } from "../../../util";
import { ReportDocument, ReportSendParameters } from "./report.model";

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 *
 * The 'type' utility function coerces strings into string
 * literal types and runs a simple check to guarantee all
 * action types in the application are unique.
 */
export const ActionTypes = {
  GENERATE: type("[Report] Generate"),
  GENERATE_SUCCESS: type("[Report] Generate Success"),
  GENERATE_FAIL: type("[Report] Generate Fail"),
  SEND: type("[Report] Send"),
  SEND_SUCCESS: type("[Report] Send Success"),
  SEND_FAIL: type("[Report] Send Fail"),
  ADD_PHOTOS_DOCUMENT: type("[Report] Add Photos Documents"),
  ADD_PHOTOS_DOCUMENT_SUCCESS: type("[Report] Add Photos Documents Success"),
  ADD_PHOTOS_DOCUMENT_FAIL: type("[Report] Add Photos Documents Fail"),
  ADD_DOCUMENTS: type("[Report] Add Documents"),
  ADD_DOCUMENTS_SUCCESS: type("[Report] Add Documents Success"),
  ADD_DOCUMENTS_FAIL: type("[Report] Add Documents Fail"),
  UPDATE_DOCUMENT: type("[Report] Update Document"),
  UPDATE_DOCUMENT_SUCCESS: type("[Report] Update Document Success"),
  UPDATE_DOCUMENT_FAIL: type("[Report] Update Document Fail"),
  REMOVE_DOCUMENT: type("[Report] Remove Document"),
  REMOVE_DOCUMENT_SUCCESS: type("[Report] Remove Document Success"),
  REMOVE_DOCUMENT_FAIL: type("[Report] Remove Document Fail"),
  SORT_DOCUMENT: type("[Report] Sort Document"),
};

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class GenerateAction implements Action {
  type = ActionTypes.GENERATE;
  constructor(public payload: string) {}
}

export class GenerateSuccessAction implements Action {
  type = ActionTypes.GENERATE_SUCCESS;
  constructor(public payload: string) {}
}

export class GenerateFailAction implements Action {
  type = ActionTypes.GENERATE_FAIL;
  constructor(public payload?: any) {}
}

export class SendAction implements Action {
  type = ActionTypes.SEND;
  constructor(public payload: ReportSendParameters) {}
}

export class SendSuccessAction implements Action {
  type = ActionTypes.SEND_SUCCESS;
  constructor(public payload?: any) {}
}

export class SendFailAction implements Action {
  type = ActionTypes.SEND_FAIL;
  constructor(public payload?: any) {}
}

export class AddPhotosDocumentAction implements Action {
  type = ActionTypes.ADD_PHOTOS_DOCUMENT;
  constructor(public payload: ReportDocument) {}
}

export class AddPhotosDocumentSuccessAction implements Action {
  type = ActionTypes.ADD_PHOTOS_DOCUMENT_SUCCESS;
  constructor(public payload: ReportDocument) {}
}

export class AddPhotosDocumentFailAction implements Action {
  type = ActionTypes.ADD_PHOTOS_DOCUMENT_FAIL;
  constructor(public payload?: any) {}
}

export class AddDocumentsAction implements Action {
  type = ActionTypes.ADD_DOCUMENTS;
  constructor(public payload: ReportDocument[]) {}
}

export class AddDocumentsSuccessAction implements Action {
  type = ActionTypes.ADD_DOCUMENTS_SUCCESS;
  constructor(public payload: ReportDocument[]) {}
}

export class AddDocumentsFailAction implements Action {
  type = ActionTypes.ADD_DOCUMENTS_FAIL;
  constructor(public payload?: any) {}
}

export class UpdateDocumentAction implements Action {
  type = ActionTypes.UPDATE_DOCUMENT;
  constructor(public payload: ReportDocument) {}
}

export class UpdateDocumentSuccessAction implements Action {
  type = ActionTypes.UPDATE_DOCUMENT_SUCCESS;
  constructor(public payload: ReportDocument) {}
}

export class UpdateDocumentFailAction implements Action {
  type = ActionTypes.UPDATE_DOCUMENT_FAIL;
  constructor(public payload?: any) {}
}

export class RemoveDocumentAction implements Action {
  type = ActionTypes.REMOVE_DOCUMENT;
  constructor(public payload: ReportDocument) {}
}

export class RemoveDocumentSuccessAction implements Action {
  type = ActionTypes.REMOVE_DOCUMENT_SUCCESS;
  constructor(public payload: ReportDocument) {}
}

export class RemoveDocumentFailAction implements Action {
  type = ActionTypes.REMOVE_DOCUMENT_FAIL;
  constructor(public payload?: any) {}
}

export class SortDocumentAction implements Action {
  type = ActionTypes.SORT_DOCUMENT;
  constructor(public payload: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Action =
  | GenerateAction
  | GenerateSuccessAction
  | GenerateFailAction
  | SendAction
  | SendSuccessAction
  | SendFailAction
  | AddPhotosDocumentAction
  | AddPhotosDocumentSuccessAction
  | AddPhotosDocumentFailAction
  | AddDocumentsAction
  | AddDocumentsSuccessAction
  | AddDocumentsFailAction
  | UpdateDocumentAction
  | UpdateDocumentSuccessAction
  | UpdateDocumentFailAction
  | RemoveDocumentAction
  | RemoveDocumentSuccessAction
  | RemoveDocumentFailAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/report/report.actions.ts